import { render } from "./DomaineExpertise.vue?vue&type=template&id=2f84cc54"
import script from "./DomaineExpertise.vue?vue&type=script&lang=js"
export * from "./DomaineExpertise.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__